<template>
  <img class="off" :src="getAssetImageUrl('common/icons/plan-off.svg')" alt="" />
  <img class="on" :src="getAssetImageUrl('common/icons/plan-on.svg')" alt="" />
</template>

<script setup lang="ts">
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
